import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';

export default function NewsSection() {
  const [featured, ...rest] = newsList;

  return (
    <section id="news" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-portal px-4 md:px-6">
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
              <span className="h-2 w-2 rounded-full bg-accent-500" />
              Film News
            </span>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">影视资讯精选</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-500">
              预告片、剧集动态与深度解读，跟上最近值得关注的光影消息。
            </p>
          </div>
          <Link
            to="/about"
            className="flex w-fit cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看栏目说明
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-12 lg:gap-5">
          <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-7">
            <div className="relative aspect-[16/9] w-full overflow-hidden bg-primary-900">
              <img
                src={featured.image}
                alt={featured.title}
                title={`${featured.title} - 青青草影视资讯`}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
              />
              <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2.5 py-1 text-[11px] font-semibold text-primary-950">
                {featured.category}
              </span>
            </div>
            <div className="p-4 md:p-6">
              <h3 className="font-heading text-lg font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-xl">
                {featured.title}
              </h3>
              <p className="mt-2.5 line-clamp-2 text-sm leading-relaxed text-foreground-500">{featured.excerpt}</p>
              <div className="mt-4 flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line text-sm" />
                  {featured.date}
                </span>
                <span className="h-3 w-px bg-background-300" />
                <span>青青草编辑部</span>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-3 lg:col-span-5">
            {rest.map((item) => (
              <article
                key={item.id}
                className="group flex cursor-pointer items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-primary-300"
              >
                <div className="h-[76px] w-[104px] shrink-0 overflow-hidden rounded-md bg-primary-900">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} - 青青草影视资讯`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0">
                  <span className="text-[11px] font-medium text-accent-600">{item.category}</span>
                  <h4 className="mt-1 line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                    <span>{item.title}</span>
                  </h4>
                  <p className="mt-1.5 text-xs text-foreground-400">{item.date}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}